import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'pcm-data-modal',
	templateUrl: './data-modal.component.html',
	styleUrls: ['./data-modal.component.scss']
})
export class DataModalComponent implements OnInit, OnDestroy {

	// for page content
	@Input() pageNotTable = true;

	@Input() title = '';
	@Input() helpText = '';
	@Input() addHelpText = '';
	@Input() modalData;	
	@Input() dataConfig;
	@Input() dataObj;
	// @Input() submitLabel = 'Submit';
	// @Input() needComments = false;

	@Input() pageTitle = '';
	@Input() fieldsOnly = false;
	@Input() onlyObject = '';
	@Input() onlyEdits = false;
	@Input() forceEdits = false;
	@Input() alsoEdits = false;
	@Input() forceApply = true;
	@Input() onlyApprovals = false;
	@Input() allowCancel = false;
	@Input() allowDelete = false;
	@Input() allowClose = false;
	@Input() aclOverwrite = false;
	@Input() allClean = false;
	@Input() showUnsaved = false;
	@Input() showObjectTitle = true;
	@Input() useLax = false;
	@Input() forceTitle = false;
	@Input() textIsError = false;
	@Input() simpleOK = false;

	@Input() forceButtons = false;
	@Input() textOnly = false;
	@Input() submitLabel = 'Submit';

	@Output() formSubmit: EventEmitter<any> = new EventEmitter();
	@Output() formCancel: EventEmitter<any> = new EventEmitter();

	// for table content pageNotTable = false
	@Input() tableService: any;
	@Input() columnsConfig = [];
	@Input() tableTab: any;

	clickedTableRow: any;

	constructor(
		public configService: ConfigService
	) { }

	ngOnInit() {
		if (!this.pageNotTable && this.columnsConfig.length === 0) {
			this.columnsConfig = this.configService.getTableFields(this.dataObj, false);
		}
		if (this.tableTab && !this.tableTab.pageSize) {
			this.tableTab.pageSize = this.configService.pageSize;
		}
	}

	ngOnDestroy() {
		this.modalData = undefined;
	}

	tableClick(event) {
		this.clickedTableRow = event.row;
	}

	pageFormSubmit(event) {
		event.clickedTableRow = this.clickedTableRow;
		this.formSubmit.emit(event);
	}

	pageFormCancel(event) {
		this.formCancel.emit(event);
	}

}
